import {isSwipeByExtremeImage} from '../swipe-handler';

export const moveGalleryImages = function (gallery, distance) {
    if (isSwipeByExtremeImage(gallery, distance)) {
        return;
    }

    gallery.find('.material-gallery-images-container').css({left: parseInt(gallery.attr('startPosition')) + distance});
};
